import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import Index from './pages/IndexPage';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import CommunityDetailHomes from './pages/CommunityDetail/Homes';
import CommunityDetailPlans from './pages/CommunityDetail/Plans';
import Homes from './pages/Homes';
import HomeDetail from './pages/HomeDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import Blogposts from './pages/Blogposts';
import BlogpostDetail from './pages/BlogpostDetail';
import NoRoute from './pages/NoRoute';
import PhotoGallery from './pages/PhotoGallery';
import VideoGallery from './pages/VideoGallery';
import AboutUs from './pages/AboutUs';
import AgentDetail from './pages/AgentDetail';
import Agents from './pages/Agents';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Energy from './pages/Energy';
import BuildLot from './pages/BuildLot';
import FinancingInfo from './pages/FinancingInfo';
import ReferAFriend from './pages/ReferAFriend';
import ContactUs from './pages/ContactUs';
import Warranty from './pages/Warranty';
import Testimonials from './pages/Testimonials';
import HomebuildingProcess from './pages/HomebuildingProcess';
import DesignCenter from './pages/DesignCenter';
import KitchenRemodels from './pages/KitchenRemodels';
import BathroomRemodels from './pages/BathroomRemodels';
import BasementFinishing from './pages/BasementFinishing';
import Additions from './pages/Additions';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalSimple"
      components={[
        { override: 'Index', component: Index },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunityDetailHomes', component: CommunityDetailHomes },
        { override: 'CommunityDetailPlans', component: CommunityDetailPlans },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: Blogposts },
        { override: 'BlogpostDetail', component: BlogpostDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'agent-detail', exact: true, path: '/agents/:agentId', component: AgentDetail },
        { name: 'agents', exact: true, path: '/agents', component: Agents },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PhotoGallery },
        { name: 'photo-gallery-filtered', exact: true, path: '/photo-gallery/:gallery', component: PhotoGallery },
        { name: 'video-gallery', exact: true, path: '/video-gallery', component: VideoGallery },
        { name: 'video-gallery-filtered', exact: true, path: '/video-gallery/:gallery', component: VideoGallery },
        { name: 'about-us', exact: true, path: '/about-us', component: AboutUs },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: Privacy },
        { name: 'terms-conditions', exact: true, path: '/terms-conditions', component: Terms },
        { name: 'energy-efficiency', exact: true, path: '/energy-efficiency', component: Energy },
        { name: 'build-on-your-lot', exact: true, path: '/build-on-your-lot', component: BuildLot },
        { name: 'financing-info', exact: true, path: '/financing-info', component: FinancingInfo },
        { name: 'refer-a-friend', exact: true, path: '/refer-a-friend', component: ReferAFriend },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'warranty-request', exact: true, path: '/warranty-request', component: Warranty },
        { name: 'testimonials', exact: true, path: '/testimonials', component: Testimonials },
        { name: 'homebuilding-process', exact: true, path: '/homebuilding-process', component: HomebuildingProcess },
        { name: 'design-center', exact: true, path: '/design-center', component: DesignCenter },
        { name: 'kitchen-remodels', exact: true, path: '/kitchen-remodels', component: KitchenRemodels },
        { name: 'bathroom-remodels', exact: true, path: '/bathroom-remodels', component: BathroomRemodels },
        { name: 'basement-finishing', exact: true, path: '/basement-finishing', component: BasementFinishing },
        { name: 'additions', exact: true, path: '/additions', component: Additions },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js